import auth from "./auth";
import combos from "./combos";
import condos from "./condos";
import contracts from "./contracts";
import points from "./points";
import sms from "./sms";
import plans from "./plans";
import client from "./client";
import cars from "./cars";
import carTransfers from "./car-transfers";
import drivers from "./drivers";
import leads from "./leads";
import tenant from "./tenant";
import internalAffairs from "./internal-affairs";

export default { auth, combos, condos, cars, carTransfers, drivers, contracts, points, sms, plans, client, tenant, leads, internalAffairs };
